import { createSlice } from "@reduxjs/toolkit";
import { api } from "../../app/api";

const initialState = {
  // The access token used to authenticate requests to the API
  accessToken: window.localStorage.getItem("token") || undefined,

  // The authenticated username
  username: window.localStorage.getItem("username") || undefined,
  
  // User permissions
  permissions: window.localStorage.getItem("permissions") || undefined,
};

export const selectAccessToken = (state) => state.auth.accessToken;
export const selectUserName = (state) => state.auth.username;
export const selectUserPermissions = (state) => state.auth.permissions;

// Save the access token to local storage
export function saveAccessToken(accessToken) {
  window.localStorage.setItem("token", accessToken);
}

// Save the access token, username, and permissions to local storage
export function saveCredentials(accessToken, username, permissions) {
  saveAccessToken(accessToken);
  window.localStorage.setItem("username", username);
  if (permissions) {
    window.localStorage.setItem("permissions", permissions);
  }
}

// Remove the access token, username, and permissions from local storage
function removeCredentials() {
  window.localStorage.removeItem("token");
  window.localStorage.removeItem("username");
  window.localStorage.removeItem("permissions");
}

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout: (state) => {
      // This private reducer is not exported. The logout function below is the
      // public interface to log out, which also removes credentials from local
      // storage.
      state.accessToken = undefined;
      state.username = undefined;
      state.permissions = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(api.endpoints.login.matchFulfilled, (state, action) => {
      // Store permissions in state regardless of value
      state.permissions = action.payload.permissions;
      
      // Get the authentication from a successful login response from the API
      // Only update token and username if permissions are not pending
      if (action.payload.permissions !== 'pending') {
        state.accessToken = action.payload.access_token;
        state.username = action.meta.arg.originalArgs.username;
      }
    })
  },
});

// Log out of the application.
//
// Call this instead of dispatching the logout() action directly, since this
// function also removes the token from the browser local storage.
export function logout() {
  return function logoutThunk(dispatch) {
    removeCredentials();
    dispatch(authSlice.actions.logout());
  };
}

export default authSlice.reducer;